import { menuFromHTML } from '@evermade/menu-toolkit';

function desktopMenu() {
	const init = () => {
		const config = window.emHeaderConfig;
		const menus = document.querySelectorAll('.js-desktop-menu');

		menus.forEach((menu) => {
			// Trying to prevent double initialization by Cookiebot
			if (menu.classList.contains('is-ready')) {
				return;
			}

			menuFromHTML(menu, {
				action: 'hover', // 'click' or 'hover'
				subMenuAnchorSelector:
					'.header-menu-desktop__list > .menu-item-has-children > a',
				subMenuListItemSelector:
					'.header-menu-desktop__list > .menu-item-has-children',
				buttonIcon:
					'<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.66 8.04c-.2.09-.53.41-.63.62-.1.21-.09.48.01.7.12.26 6.34 6.48 6.6 6.6.23.1.49.1.72 0a158 158 0 0 0 6.6-6.6c.16-.36.07-.72-.27-1.07-.33-.33-.69-.41-1.05-.25-.14.07-.82.72-2.91 2.81L12 13.58l-2.73-2.73a39.02 39.02 0 0 0-2.91-2.8.87.87 0 0 0-.7-.02"/></svg>',
				expandChildMenuText: config.text.expandChildMenuText,
				shouldWrapAnchorToButton: false, // Force all sub-menu toggles to be buttons and not separate link + toggle
				hoverTimeout: 1250,
				animateOpen: true,
				animateClose: true,
				animateOpenClass: 'animate-open',
				animateCloseClass: 'animate-close',
				animateOpenMaxExecutionTime: 250,
				animateCloseMaxExecutionTime: 250,
				onBeforeOpenSubMenu: (ul) => {
					// check that sub-menu fits on right side of parent
					if (
						ul.getBoundingClientRect().right >
						(window.innerWidth ||
							document.documentElement.clientWidth)
					) {
						ul.classList.add('is-out-of-bounds');
					} else {
						ul.classList.remove('is-out-of-bounds');
					}
				},
				onAfterCloseSubMenu: (ul) => {
					ul.classList.remove('is-out-of-bounds');
				},
			});
		});
	};

	init();
}

export default desktopMenu;
